<template>
  <button v-if="canShowList" class="btn btn-xs btn-outline" @click.stop="showList">
    <i class="fas fa-list"></i>
  </button>
</template>

<script>
export default {
  props: {
    row: Object,
    index: Number,
  },

  computed: {
    /**
     * @return {string}
     */
    listUrl() {
      return this.row.noteIndexUrl;
    },

    /**
     * @return {boolean}
     */
    canShowList() {
      return this.row.canNoteIndex;
    },
  },

  methods: {
    /**
     * @event show-list
     */
    showList() {
      this.$emit('show-list', {url: this.listUrl});
    },
  },
}
</script>
